import { MAIN_URL } from '../../settings';
import { controllingSetOpenOptions, controllingSetHelperStatus } from '../../store/controlling/actions';
import About from '../About';
import Confirm from '../Confirm';
import styles from './Options.module.scss';
import aboutSvg from './assets/about.svg';
import clearSvg from './assets/clear.svg';
import exitSvg from './assets/exit.svg';
import fitToScreenSvg from './assets/fitToScreen.svg';
import helpSvg from './assets/help.svg';
import layerSvg from './assets/layer.svg';
import oneToOneSvg from './assets/oneToOne.svg';
import saveSvg from './assets/save.svg';
import snapshotSvg from './assets/snapshot.svg';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';

const Options = ({ engine = {} }) => {
  const dispatch = useDispatch();
  const open = useSelector((s) => s.controlling.openOptions);
  const { t } = useTranslation();
  const [confirmExit, setConfirmExit] = useState(false);
  const [about, setAbout] = useState(false);

  return (
    <>
      {open && (
        <div
          className={styles.container}
          onClick={() => {
            dispatch(controllingSetOpenOptions(false));
          }}
        >
          <div className={styles.menu}>
            <div className={styles.item} onClick={engine.fitToNaturalScale}>
              <div className={styles.icon}>
                <img src={oneToOneSvg} alt="1:1 scale" />
              </div>
              <div className={styles.description}>1:1 scale</div>
            </div>

            <div className={styles.item} onClick={engine.clearWetScreen}>
              <div className={styles.icon}>
                <img src={clearSvg} className={styles.clear} alt="Clean wet layers" />
              </div>
              <div className={styles.description}>Clean wet layers</div>
            </div>

            <div className={styles.item} onClick={engine.fitToScreen}>
              <div className={styles.icon}>
                <img src={fitToScreenSvg} alt={t('Fit to screen')} />
              </div>
              <div className={styles.description}>{t('Fit to screen')}</div>
            </div>

            <div className={styles.item} onClick={engine.makeSnapshot}>
              <div className={styles.icon}>
                <img src={snapshotSvg} alt="Make snapshot" />
              </div>
              <div className={styles.description}>Make snapshot</div>
            </div>

            <div className={styles.item} onClick={engine.saveCurrentLayer}>
              <div className={styles.icon}>
                <img src={layerSvg} alt="Save current layer" />
              </div>
              <div className={styles.description}>Save current layer</div>
            </div>

            <div
              className={styles.item}
              onClick={() => {
                dispatch(controllingSetHelperStatus(true));
              }}
            >
              <div className={styles.icon}>
                <img src={helpSvg} alt="Help" />
              </div>
              <div className={styles.description}>Help</div>
            </div>

            <div className={styles.item} onClick={engine.save}>
              <div className={styles.icon}>
                <img src={saveSvg} className={styles.save} alt={t('Save')} />
              </div>
              <div className={styles.description}>{t('Save')}</div>
            </div>

            <div
              className={styles.item}
              onClick={() => {
                setAbout(true);
              }}
            >
              <div className={styles.icon}>
                <img src={aboutSvg} className={styles.save} alt={t('About')} />
              </div>
              <div className={styles.description}>{t('About')}</div>
            </div>

            <div
              className={styles.item}
              onClick={() => {
                setConfirmExit(true);
              }}
            >
              <div className={styles.icon}>
                <img src={exitSvg} className={styles.exit} alt={t('Exit')} />
              </div>
              <div className={styles.description}>{t('Exit')}</div>
            </div>
          </div>
        </div>
      )}

      {confirmExit && (
        <Confirm
          text={t('Do you want to leave app?')}
          handleNo={() => {
            setConfirmExit(false);
          }}
          handleYes={() => {
            window.location.href = MAIN_URL;
          }}
        />
      )}

      {about && (
        <About
          handleClose={() => {
            setAbout(false);
          }}
        />
      )}
    </>
  );
};

export default Options;
